import React from "react"
import ReactDOM from "react-dom/client"
import App from "./app.js"

// auto set defaults
{
  !window.localStorage.getItem("lng") &&
    window.localStorage.setItem("lng", "en")
  !window.localStorage.getItem("medusa_admin_theme") &&
    window.localStorage.setItem("medusa_admin_theme", "light")
}

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
)
